import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as userAndPermissionActions from "redux/app/userAndPermission/Actions";
import * as projectsActions from "redux/app/projects/Actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import MultiSelect from "../../../components/forms/MultiSelect";
import { useIntlMessage } from "util/getIntlMessage";
import { permissionOptionsForNonAdminUser } from "util/data/reactTableData";

const AddProjectPermissionForm = ({ setModal, userId }) => {
  const localizationMessage = useIntlMessage();
  const [projectListArray, setProjectListArray] = useState([]);

  const dispatch = useDispatch();

  const {
    projectEntity,
    loadingButton
  } = useSelector(
    state => ({
      projectEntity: state.project.entity,
      loadingButton: state?.buttonLoading?.loading
    }),
    shallowEqual
  );

  //Initial State
  const InitialState = {
    projectField: [],
    permissionField: "",
  };

  //Validation Schema :
  const ValidationSchema = Yup.object().shape({
    projectField: Yup.array().min(1),
    permissionField: Yup.string().required(" required"),
  });

  const SubmitHandler = async values => {
    const payload = {
      projectIds: values?.projectField || [],
      permission: values.permissionField || ""
    }
    dispatch(userAndPermissionActions.addProject(userId, payload, setModal));
  };

  //formMik Handler
  const formMik = useFormik({
    initialValues: InitialState,
    validationSchema: ValidationSchema,
    onSubmit: SubmitHandler
  });


  useEffect(() => {
    if (projectEntity.length > 0) {
      if (projectEntity) {
        const arr = [];
        projectEntity.map(data =>
          arr.push({ value: data?.id, label: data?.name })
        );
        setProjectListArray(arr);
      }
    }

  }, [projectEntity]);

  useEffect(() => {
    // dispatch(projectsActions.getAll());
    dispatch(projectsActions.getAllUnPermissionedProjects(userId));

  }, [dispatch, userId]);

  return (
    <>
      <form id="addProjectPermissionForm" className="" onSubmit={formMik.handleSubmit}>
        {/* ********* project field ******** */}
        <div className="form-group">
          <div className="form-group">
            <MultiSelect
              name="projectField"
              options={projectListArray}
              formMik={formMik}
              ListItemName="project's" // optional prop, will be shown on select like, "6 {ListItemName} selected" ==> "6 project's selected"
              placeholderValue={localizationMessage("userAndPermission.selectRemainingProjectField.placeholder")} // optional prop, if not then placeholder will be "select item's"
              noOptionsMessage={() => localizationMessage("noItemsListed")}
            />
          </div>
        </div>
        {/* ********* permission field ******** */}
        <div className="form-group">
          <div className="form-group">
            <select
              name="permissionField"
              className={
                formMik.errors.permissionField &&
                  formMik.touched.permissionField
                  ? "is-invalid form-select"
                  : formMik.touched.permissionField
                    ? "is-valid form-select"
                    : "form-select"
              }
              onChange={formMik.handleChange}
              onBlur={formMik.handleBlur}
              value={formMik.values.permissionField}
            >
              <option value="">{localizationMessage("userAndPermission.selectPermissionField.placeholder")}</option>
              {permissionOptionsForNonAdminUser.map((item, i) => (
                <option value={item.value} key={i}>
                  {/* {item.label} */}
                  {localizationMessage(item.label)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <Button className="btn form-button c-primary"
          disabled={loadingButton}
          type="submit"
        >
          {localizationMessage("add")}
        </Button>
      </form>
    </>
  );
};

export default AddProjectPermissionForm;
